import React, { useEffect, useState, useCallback } from 'react';
import './authorizations.css';
import Sidebar from '../../components/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useAuthorization } from '../../context/authorizationContext';
import { toast } from 'react-toastify';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import BinaryImage from '../../components/BinaryImage';
import BinaryFileLink from '../../components/BinaryFileLink';
import { BINARY_RESOURCES, hasBinaryField, resolveThumbnailField } from '../../utils/binaryFile';

const DisciplineAuthorizationVisite = () => {
  const {
    listAuthorizations,
    getAuthorizationDetails,
    updateDisciplineAuthorization,
  } = useAuthorization();
  const [requests, setRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedVisitorId, setSelectedVisitorId] = useState(null);
  const [motive, setMotive] = useState('');
  const [isAccepting, setIsAccepting] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);

  const fetchRequests = useCallback(async () => {
    try {
      const data = await listAuthorizations("discipline");
      setRequests(data.results || []);
    } catch (error) {
      toast.error('Erro ao carregar solicitações de Disciplina.');
    }
  }, [listAuthorizations]);

  useEffect(() => {
    fetchRequests();
  }, [fetchRequests]);

  const handleViewDetails = async (visitorId) => {
    if (selectedVisitorId === visitorId) {
      setSelectedRequest(null); // Fechar se já estiver aberto
      setSelectedVisitorId(null);
      setMotive('')
    } else {
      try {
        const data = await getAuthorizationDetails(visitorId);
        setSelectedRequest(data);
        setSelectedVisitorId(visitorId);
      } catch (error) {
        toast.error('Erro ao carregar detalhes da solicitação.');
      }
    }
  };

  const handleAccept = async (id) => {
    if (isAccepting || isRejecting) return;
    setIsAccepting(true);
    try {
      await updateDisciplineAuthorization(id, 'Autorizado', motive, true);
      await fetchRequests(); // Atualiza a tabela
      setSelectedRequest(null);
      setSelectedVisitorId(null);
    } catch (error) {
      toast.error('Erro ao aceitar autorização.');
    } finally {
      setIsAccepting(false);
    }
  };

  const handleReject = async (id) => {
    if (isAccepting || isRejecting) return;
    setIsRejecting(true);
    try {
      await updateDisciplineAuthorization(id, 'Não autorizado', motive, true);
      await fetchRequests(); // Atualiza a tabela
      setSelectedRequest(null);
      setSelectedVisitorId(null);
    } catch (error) {
      toast.error('Erro ao rejeitar autorização.');
    } finally {
      setIsRejecting(false);
    }
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container'>
        <Titulo
          children={
            <h2>Visitantes pendentres</h2>
          }
        />
        <div className='content'>
          <div className="table-container">
            <table className="requests-table">
              <thead>
                <tr>
                  <th>Nome do Visitante</th>
                  <th>Status da Disciplina</th>
                  <th>Status do Serviço Social</th>
                  <th>Detalhes</th>
                </tr>
              </thead>
              <tbody>
                {requests.length > 0 ? (
                  requests.map((request) => (
                    <React.Fragment key={request.id}>
                      <tr>
                        <td>{request.visitor_name || 'Desconhecido'}</td>
                        <td>{request.discipline_authorization || 'Indefinido'}</td>
                        <td>{request.social_worker_authorization || 'Indefinido'}</td>
                        <td>
                          <FontAwesomeIcon
                            icon={faEye}
                            className="view-icon"
                            onClick={() => handleViewDetails(request.visitor)}
                          />
                        </td>
                      </tr>
                      {selectedVisitorId === request.visitor && selectedRequest && (
                        <tr>
                          <td colSpan="4">
                            <div className='content-details'>
                              <div className="details-section">
                                <h3>Detalhes da Solicitação
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    className="view-icon"
                                    onClick={() => handleViewDetails(request.visitor)}
                                  />
                                </h3>

                                {/* Dados da Autorização */}
                                <h4>Dados da Autorização:</h4>
                                {selectedRequest.authorization?.[0] && (
                                  <div className="authorization-details">
                                    <p><strong>Status (Disciplina):</strong> {selectedRequest.authorization[0].discipline_authorization}</p>
                                    <p><strong>Motivo (Disciplina):</strong> {selectedRequest.authorization[0].discipline_motive || 'Sem motivo informado'}</p>
                                    <p><strong>Status (Serviço Social):</strong> {selectedRequest.authorization[0].social_worker_authorization}</p>
                                    <p><strong>Motivo (Serviço Social):</strong> {selectedRequest.authorization[0].social_worker_motive || 'Sem motivo informado'}</p>
                                  </div>
                                )}
                                <br />
                                {/* Interno relacionado */}
                                <h4>Interno relacionado:</h4>
                                {selectedRequest.relationship && (
                                  <div className="relationship-details">
                                    <p><strong>Nome do Interno:</strong> {selectedRequest.relationship[0].internal_name}</p>
                                    <p><strong>Relação com o Interno:</strong> {selectedRequest.relationship[0].type_relationship_name}</p>
                                  </div>
                                )}
                                <br />
                                {/* Dados do Visitante */}
                                <h4>Dados do Visitante:</h4>
                                {selectedRequest.visitor?.[0] && (
                                  <div className="visitor-details">
                                    <p><strong>Nome:</strong> {selectedRequest.visitor[0].name}</p>
                                    <p><strong>CPF:</strong> {selectedRequest.visitor[0].cpf}</p>
                                    <p><strong>Idade:</strong> {selectedRequest.visitor[0].age}</p>
                                    <p><strong>Email:</strong> {selectedRequest.visitor[0].email}</p>
                                  </div>
                                )}
                                <br />
                                {/* Dados do Endereço */}
                                <h4>Endereço:</h4>
                                {selectedRequest.address?.[0] && (
                                  <div className="address-details">
                                    <p><strong>Cidade:</strong> {selectedRequest.address[0].city}</p>
                                    <p><strong>Bairro:</strong> {selectedRequest.address[0].neighborhood}</p>
                                    <p><strong>Logradouro:</strong> {selectedRequest.address[0].public_place}</p>
                                  </div>
                                )}
                                <br />

                                {/* Telefones */}
                                <h4>Telefones</h4>
                                {selectedRequest.phones?.map((phone, index) => (
                                  <div key={index} className="phone-details">
                                    <p><strong>Título:</strong> {phone.title}</p>
                                    <p><strong>Número:</strong> {phone.number}</p>
                                  </div>
                                ))}
                                <br />
                                {/* Arquivos */}
                                <h4>Arquivos</h4>
                                {selectedRequest.files?.map((file, index) => (
                                  <div key={index} className="file-details">
                                    <p><strong>Tipo:</strong> {file.type_file}</p>
                                    {hasBinaryField(file, 'file') ? (
                                      <BinaryFileLink resource={BINARY_RESOURCES.visitorFile} id={file.id} field="file">Visualizar Arquivo</BinaryFileLink>
                                    ) : (
                                      <p>Arquivo indisponível</p>
                                    )}
                                  </div>
                                ))}
                                <br />
                                {/* Imagens */}
                                <h4>Imagens</h4>
                                {selectedRequest.images?.map((image, index) => (
                                  <div key={index} className="image-details">
                                    <p><strong>Tipo:</strong> {image.type_image}</p>
                                    <BinaryImage resource={BINARY_RESOURCES.visitorImage} id={image.id} field={resolveThumbnailField(image)} alt={image.type_image} className="authorization-image" />
                                  </div>
                                ))}
                                <br />
                                {/* Textarea para motivo e botões de ação */}
                                <div className="card-actions">
                                  <h3>Motivo:</h3>
                                  <textarea
                                    placeholder="Informe o motivo"
                                    value={motive}
                                    onChange={(e) => setMotive(e.target.value)}
                                    disabled={isAccepting || isRejecting}
                                  />
                                  <button
                                    onClick={() => handleAccept(selectedRequest.authorization[0].id)}
                                    className="accept"
                                    disabled={isAccepting || isRejecting}
                                  >
                                    {isAccepting ? 'Enviando...' : 'Aceitar'}
                                  </button>
                                  <button
                                    onClick={() => handleReject(selectedRequest.authorization[0].id)}
                                    className="reject"
                                    disabled={isAccepting || isRejecting}
                                  >
                                    {isRejecting ? 'Enviando...' : 'Rejeitar'}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">Não há solicitações pendentes.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisciplineAuthorizationVisite;
